import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../../util/googleAnalytics';

/**
 * Sends GA4 page_view on every client-side route change (all <Route> pages).
 */
export default function GoogleAnalyticsRouteListener() {
    const location = useLocation();

    useEffect(() => {
        trackPageView();
    }, [location.pathname, location.search]);

    return null;
}
